<!-- 普通用户或者管理员的后台管理页面 -->
<template>
<div class="amdin">
  <v-nav class="transition" :collapse="collapse" :menuList="menuList" :style="{width:pageSize.navWidth+'px'}" :pageSize="pageSize" @change-activeName="hanldeActiveName"></v-nav>
  <v-header class="transition" :collapse.sync="collapse" :breadcrumbList="breadcrumbList" :style="{left:pageSize.navWidth+'px'}" :pageSize="pageSize" @change-activeName="hanldeActiveName"></v-header>
  <div class="transition content-wrapper" :style="{left:pageSize.navWidth+'px'}">
    <router-view/>
    <back-top :height="100" :bottom="80" :right="50" container=".content-wrapper"></back-top>
  </div>
  <v-footer class="transition" :style="{left:pageSize.navWidth+'px'}"></v-footer>
</div>
</template>

<script>
import backTop from '@/components/public/back-top';
import vNav from '@/components/public/nav';
import vHeader from '@/components/public/header';
import vFooter from './footer';

import {
  mapMutations
} from 'vuex';
import {
  getParentName
} from '@/libs/utils';
import {
  purposeGet
} from '@/libs/api';

export default {
  components: {
    backTop,
    vNav,
    vHeader,
    vFooter
  },
  data() {
    return {
      collapse: false
    };
  },
  watch: {
    '$route' (oldRoute) {
      const title = oldRoute.meta.title || "";
      const name = oldRoute.name;
      if (oldRoute.name === 'device') {
        this.setBreadcrumb([{
          name: 'app',
          meta: {
            title: '应用管理'
          }
        }, {
          name,
          meta: {
            title
          }
        }])
      } else {
        this.setBreadcrumb([{
          name,
          meta: {
            title
          }
        }])
      }
    }
  },
  computed: {
    pageSize() {
      return this.$store.state.admin.pageSize
    },
    menuList() { //获取菜单列表
      return this.$store.getters.menuList
    },
    breadcrumbList() {
      return this.$store.state.admin.breadcrumb
    }
  },
  methods: {
    ...mapMutations(['setRoot', 'setActiveName', 'setAccountMessage', 'setBreadcrumb', 'setChoices']),
    hanldeActiveName(name) {
      this.setActiveName(name)
    }
  },
  mounted() {
    this.setActiveName(this.$route.name)
    const msg = sessionStorage.getItem("setAccountMessage")
    this.setAccountMessage(msg && JSON.parse(msg) || undefined)
    this.setRoot(this.$route)
    this.setBreadcrumb([{
      name: this.$route.name,
      meta: {
        title: this.$route.meta.title
      }
    }])
    if (this.$store.state.admin.root === "web") {
      purposeGet(this.language).then((res) => {
        res = res.data;
        if (res.code === 1000) {
          this.setChoices({
            scene_choices: res.scene_choices,
            trade_choices: res.trade_choices
          })
        }
      });
    }
    this.$nextTick(() => {
      const baiduID = document.getElementById('newBridge');
      baiduID && (baiduID.style.display = 'none')
    })
  }
};
</script>

<style lang="less" scoped>
.amdin {
  width: 100%;
  height: 100%;
  .content-wrapper {
    position: absolute;
    right: 0;
    bottom: 40px;
    top: 60px;
    padding: 18px;
    overflow: hidden;
    overflow-y: auto;
    background-color: #fff;
  }
  .transition {
    transition: 0.3s all ease-in-out;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/home.vue